export * from './PlusToXRotatingIcon';
